// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.verifier-buttton .dropdown-toggle:after {
  display: none;
}

.verifier-buttton .dropdown-toggle:hover {
  width: auto;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.custom-dropdown-container {
  position: relative;
    display: flex;
    padding: 10px 0px;
    color: rgb(230, 25, 209);
    background-color: rgb(255, 255, 255);
    border-radius: 0px;
    font-size: 22px;
    transition: 0.3s;
    border-bottom: 1px solid rgb(227, 43, 124);
    /* margin-bottom: 100px; */
}

.dropdown-toggle {
  background-color: transparent !important;
  color: rgb(230, 25, 209) !important;
  border: 0px;
  padding: 0px;
  font-family: 'Brandon Grot W01 Light';
}

.dropdown-toggle:hover {
  background-color: #ec2e7b !important;
  color: white !important;
  width: 100%;
  text-align: left;
  border-radius: 0px;
}

.dropdown-toggle::after {
  position: absolute;
    top: 45%;
    right: 20px;
    content: '';
    width: 10px;
    height: 10px;
    border-right: 1px solid #ec2e7b;
    border-bottom: 1px solid #ec2e7b;
    transform: rotate(45deg) translateX(-45%);
    transition: 0.3s ease-in-out;
}

.dropdown-item-container {
  width: 100%;
    background-color: rgb(89, 89, 91);
    border-radius: 0px;
    position: absolute;
    inset: 0px auto auto 0px;
    transform: translate(10px, 45px);
    overflow-x: auto;
    max-height: 175px;
}

.custom-dropdown-item {
  height: 55px;
  padding: 10px;
  color: white;
  font-family: 'Brandon Grot W01 Light';
  font-size: x-large;
}

.custom-dropdown-item:hover {
  background-color: #ec2e7b;
}

.rating-control {
  input[type="radio"] {
    display: none;
  }
}

.star {
  /* cursor: pointer; */
  font-size: 1.5rem;
  margin: 5px;
}
.verifier-buttton .dropdown-toggle:after {
  display: none;
}

.verifier-buttton .dropdown-toggle:hover {
  width: auto;
}

/* *******************************
message-area
******************************** */

.message-area {
  height: 100vh;
  overflow: hidden;
  padding: 30px 0;
  background: #f5f5f5;
}

.chat-area {
  position: relative;
  width: 100%;
  background-color: #fff;
  border-radius: 0.3rem;
  height: 90vh;
  overflow: hidden;
  min-height: calc(100% - 1rem);
}

.chatlist {
  outline: 0;
  height: 100%;
  overflow: hidden;
  width: 300px;
  float: left;
  /* padding: 15px; */
  background-color: #8a8a8a;
}

.chat-area .modal-content {
  border: none;
  border-radius: 0;
  outline: 0;
  height: 100%;
  margin: 0px!important;
}

.chat-area .modal-dialog-scrollable {
  height: 100% !important;
}

.message-area .chatbox {
  width: auto;
  overflow: hidden;
  height: 100%;
  border-left: 1px solid #ccc;
}

.chatbox .modal-dialog,
.chatlist .modal-dialog {
  max-width: 100%;
  margin: 0;
}

.msg-search {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.chat-area .form-control {
  display: block;
  width: 80%;
  padding: 0.375rem 0.75rem;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: #222;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ccc;
  appearance: none;
  border-radius: 0.25rem;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.chat-area .form-control:focus {
  outline: 0;
  box-shadow: inherit;
}

.message-area a.add img {
  height: 36px;
}

.chat-area .nav-tabs {
  border-bottom: 1px solid #dee2e6;
  align-items: center;
  justify-content: space-between;
  flex-wrap: inherit;
}

.chat-area .nav-tabs .nav-item {
  width: 100%;
}

.chat-area .nav-tabs .nav-link {
  width: 100%;
  color: #180660;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  text-transform: capitalize;
  margin-top: 5px;
  margin-bottom: -1px;
  background: 0 0;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.chat-area .nav-tabs .nav-item.show .nav-link,
.chat-area .nav-tabs .nav-link.active {
  color: #222;
  background-color: #fff;
  border-color: transparent transparent #000;
}

.chat-area .nav-tabs .nav-link:focus,
.chat-area .nav-tabs .nav-link:hover {
  border-color: transparent transparent #000;
  isolation: isolate;
}

.chat-list h3 {
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  text-transform: capitalize;
  margin-bottom: 0;
}

.chat-list p {
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  text-transform: capitalize;
  margin-bottom: 0;
}

.chat-list a.d-flex {
  /* margin-bottom: 15px; */
  position: relative;
  text-decoration: none;
  padding: 10px;
}



.chat-list .active,
.message-active
 {
  display: block;
  content: '';
  clear: both;
  position: absolute;
  top: 40%;
  right: 20px;
  height: 12px;
  width: 12px;
  background: #ec2e7a;
  border-radius: 50%;
  border: 2px solid #fff;
  
}

.msg-head h3 {
  color: #222;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.5;
  margin-bottom: 0;
}

.msg-head p {
  color: #343434;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  text-transform: capitalize;
  margin-bottom: 0;
}

.msg-head {
  padding: 15px;
  border-bottom: 1px solid #ccc;
}

.moreoption {
  display: flex;
  align-items: center;
  justify-content: end;
}

.moreoption .navbar {
  padding: 0;
}

.moreoption li .nav-link {
  color: #222;
  font-size: 16px;
}

.moreoption .dropdown-toggle::after {
  display: none;
}

.moreoption .dropdown-menu[data-bs-popper] {
  top: 100%;
  left: auto;
  right: 0;
  margin-top: 0.125rem;
}


.msg-body ul {
  overflow: hidden;
}

.msg-body ul li {
  list-style: none;
  margin: 15px 0;
}

.msg-body ul li.sender {
  display: block;
  width: 100%;
  position: relative;
}

.msg-body ul li.sender:before {
  /* display: block;
  clear: both;
  content: '';
  position: absolute;
  top: -6px;
  left: -7px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 12px 15px 12px;
  border-color: transparent transparent #f5f5f5 transparent;
  -webkit-transform: rotate(-37deg);
  -ms-transform: rotate(-37deg);
  transform: rotate(-37deg); */
}

.msg-body ul li.sender p {
  color: #000;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
  padding: 15px;
  background: #f5f5f5;
  display: inline-block;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  margin-bottom: 0;
}

.msg-body ul li.sender p b {
  display: block;
  color: #180660;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 500;
}

.msg-body ul li.repaly {
  display: block;
  width: 100%;
  text-align: right;
  position: relative;
}

.msg-body ul li.repaly:before {
  display: block;
  clear: both;
  content: '';
  position: absolute;
  bottom: 15px;
  right: -7px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 12px 15px 12px;
  border-color: transparent transparent #eb307b transparent;
  transform: rotate(37deg);
}

.msg-body ul li.repaly p {
  color: #fff;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
  padding: 15px;
  background: #eb307b;
  display: inline-block;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;
  margin-bottom: 0;
  text-align: justify;
}

.msg-body ul li.repaly p b {
  display: block;
  color: #061061;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 500;
}

.msg-body ul li.repaly:after {
  display: block;
  content: '';
  clear: both;
}

.time {
  display: block;
  color: #000;
  font-size: 12px;
  line-height: 1.5;
  font-weight: 400;
}

.message-area li.repaly .time {
  margin-right: 20px;
}

.divider {
  position: relative;
  z-index: 1;
  text-align: center;
}

.msg-body h6 {
  text-align: center;
  font-weight: normal;
  font-size: 14px;
  line-height: 1.5;
  color: #222;
  background: #fff;
  display: inline-block;
  padding: 0 5px;
  margin-bottom: 0;
}

.divider:after {
  display: block;
  content: '';
  clear: both;
  position: absolute;
  top: 12px;
  left: 0;
  border-top: 1px solid #EBEBEB;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.send-box {
  padding: 15px;
  border-top: 1px solid #ccc;
}

.send-box form {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

.send-box .form-control {
  display: block;
  width: 85%;
  padding: 0.375rem 0.75rem;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: #222;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ccc;
  appearance: none;
  border-radius: 0.25rem;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.send-box button {
  border: none;
  background: #eb307b;
  padding: 0.375rem 5px;
  color: #fff;
  border-radius: 0.25rem;
  font-size: 14px;
  font-weight: 400;
  width: 24%;
  margin-left: 1%;
}
.send-box button i {
  margin-right: 5px;
}

.send-btns .button-wrapper {
  position: relative;
  width: 125px;
  height: auto;
  text-align: left;
  margin: 0 auto;
  display: block;
  background: #F6F7FA;
  border-radius: 3px;
  padding: 5px 15px;
  float: left;
  margin-right: 5px;
  margin-bottom: 5px;
  overflow: hidden;
}

.send-btns .button-wrapper span.label {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  color: #343945;
  font-weight: 400;
  text-transform: capitalize;
  font-size: 13px;
}

#upload {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}

.send-btns .attach .form-control {
  display: inline-block;
  width: 120px;
  height: auto;
  padding: 5px 8px;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.5;
  color: #343945;
  background-color: #F6F7FA;
  background-clip: padding-box;
  border: 1px solid #F6F7FA;
  border-radius: 3px;
  margin-bottom: 5px;
}

.send-btns .button-wrapper span.label img {
  margin-right: 5px;
}

.button-wrapper {
  position: relative;
  width: 100px;
  height: 100px;
  text-align: center;
  margin: 0 auto;
}

.message-area button:focus {
  outline: 0;
}

.add-apoint {
  display: inline-block;
  margin-left: 5px;
}

.add-apoint a {
  text-decoration: none;
  background: #F6F7FA;
  border-radius: 8px;
  padding: 8px 8px;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.2;
  color: #343945;
}

.add-apoint a svg {
  margin-right: 5px;
}

.chat-icon {
  display: none;
}

.closess i {
  display: none;
}
.message-area .modal-content{
  margin-top: 0;
}


@media (max-width: 767px) {
  .chat-icon {
      display: block;
      margin-right: 5px;
  }
  .chatlist {
      width: 100%;
  }
  .chatbox {
      width: 100%;
      position: absolute;
      left: 1000px;
      right: 0;
      background: #fff;
      transition: all 0.5s ease;
      border-left: none;
  }
  .showbox {
      left: 0 !important;
      transition: all 0.5s ease;
  }
  .msg-head h3 {
      font-size: 14px;
  }
  .msg-head p {
      font-size: 12px;
  }
  .msg-head .flex-shrink-0 img {
      height: 30px;
  }
  .send-box button {
      width: 28%;
  }
  .send-box .form-control {
      width: 70%;
  }
  .chat-list h3 {
      font-size: 14px;
  }
  .chat-list p {
      font-size: 12px;
  }
  .msg-body ul li.sender p {
      font-size: 13px;
      padding: 8px;
      border-bottom-left-radius: 6px;
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
  }
  .msg-body ul li.repaly p {
      font-size: 13px;
      padding: 8px;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      border-bottom-left-radius: 6px;
  }
}

section.message-area.chat .tab-content .tab-pane {
  padding: 0px !important;
}

.bottom-scroll {
  overflow:auto; 
  display:flex !important; 
  flex-direction:column-reverse !important;
}

.alert-pitch-danger {
  --vz-alert-color: #ec3087;
  --vz-alert-bg: #FFE957;
  --vz-alert-border-color: #ffc107;
  --vz-alert-link-color: #ec3087;
}

.alert-pitch-gray {
  --vz-alert-color: #D8D8D8;
  --vz-alert-bg: #989898;
  --vz-alert-border-color: #989898;
  --vz-alert-link-color: #D8D8D8;
}
.button-gray {
  padding: 10px 20px;
  border: none;
  background-color: #989898;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}
.button-gray:hover {
  background: #989898 !important;
  box-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;IAChB,aAAa;IACb,iBAAiB;IACjB,wBAAwB;IACxB,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,0CAA0C;IAC1C,0BAA0B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;IAChB,QAAQ;IACR,WAAW;IACX,WAAW;IACX,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,gCAAgC;IAChC,yCAAyC;IACzC,4BAA4B;AAChC;;AAEA;EACE,WAAW;IACT,iCAAiC;IACjC,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;;kCAEkC;;AAElC;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;;EAEE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,UAAU;EACV,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,sBAAsB;EAGtB,gBAAgB;EAChB,sBAAsB;EACtB,sEAAsE;AACxE;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;;EAEE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;AACf;;;;AAIA;;;EAGE,cAAc;EACd,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;;AAExB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,UAAU;EACV,QAAQ;EACR,oBAAoB;AACtB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;;;;;;;;;;;;;8BAa4B;AAC9B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,+BAA+B;EAC/B,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,yDAAyD;EAGzD,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,sBAAsB;EAGtB,gBAAgB;EAChB,sBAAsB;EACtB,sEAAsE;AACxE;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EAGV,aAAa;EAGb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;;AAGA;EACE;MACI,cAAc;MACd,iBAAiB;EACrB;EACA;MACI,WAAW;EACf;EACA;MACI,WAAW;MACX,kBAAkB;MAClB,YAAY;MACZ,QAAQ;MACR,gBAAgB;MAChB,yBAAyB;MACzB,iBAAiB;EACrB;EACA;MACI,kBAAkB;MAClB,yBAAyB;EAC7B;EACA;MACI,eAAe;EACnB;EACA;MACI,eAAe;EACnB;EACA;MACI,YAAY;EAChB;EACA;MACI,UAAU;EACd;EACA;MACI,UAAU;EACd;EACA;MACI,eAAe;EACnB;EACA;MACI,eAAe;EACnB;EACA;MACI,eAAe;MACf,YAAY;MACZ,8BAA8B;MAC9B,4BAA4B;MAC5B,+BAA+B;EACnC;EACA;MACI,eAAe;MACf,YAAY;MACZ,2BAA2B;MAC3B,4BAA4B;MAC5B,8BAA8B;EAClC;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B","sourcesContent":[".App {\r\n  text-align: center;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n.verifier-buttton .dropdown-toggle:after {\r\n  display: none;\r\n}\r\n\r\n.verifier-buttton .dropdown-toggle:hover {\r\n  width: auto;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.custom-dropdown-container {\r\n  position: relative;\r\n    display: flex;\r\n    padding: 10px 0px;\r\n    color: rgb(230, 25, 209);\r\n    background-color: rgb(255, 255, 255);\r\n    border-radius: 0px;\r\n    font-size: 22px;\r\n    transition: 0.3s;\r\n    border-bottom: 1px solid rgb(227, 43, 124);\r\n    /* margin-bottom: 100px; */\r\n}\r\n\r\n.dropdown-toggle {\r\n  background-color: transparent !important;\r\n  color: rgb(230, 25, 209) !important;\r\n  border: 0px;\r\n  padding: 0px;\r\n  font-family: 'Brandon Grot W01 Light';\r\n}\r\n\r\n.dropdown-toggle:hover {\r\n  background-color: #ec2e7b !important;\r\n  color: white !important;\r\n  width: 100%;\r\n  text-align: left;\r\n  border-radius: 0px;\r\n}\r\n\r\n.dropdown-toggle::after {\r\n  position: absolute;\r\n    top: 45%;\r\n    right: 20px;\r\n    content: '';\r\n    width: 10px;\r\n    height: 10px;\r\n    border-right: 1px solid #ec2e7b;\r\n    border-bottom: 1px solid #ec2e7b;\r\n    transform: rotate(45deg) translateX(-45%);\r\n    transition: 0.3s ease-in-out;\r\n}\r\n\r\n.dropdown-item-container {\r\n  width: 100%;\r\n    background-color: rgb(89, 89, 91);\r\n    border-radius: 0px;\r\n    position: absolute;\r\n    inset: 0px auto auto 0px;\r\n    transform: translate(10px, 45px);\r\n    overflow-x: auto;\r\n    max-height: 175px;\r\n}\r\n\r\n.custom-dropdown-item {\r\n  height: 55px;\r\n  padding: 10px;\r\n  color: white;\r\n  font-family: 'Brandon Grot W01 Light';\r\n  font-size: x-large;\r\n}\r\n\r\n.custom-dropdown-item:hover {\r\n  background-color: #ec2e7b;\r\n}\r\n\r\n.rating-control {\r\n  input[type=\"radio\"] {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.star {\r\n  /* cursor: pointer; */\r\n  font-size: 1.5rem;\r\n  margin: 5px;\r\n}\r\n.verifier-buttton .dropdown-toggle:after {\r\n  display: none;\r\n}\r\n\r\n.verifier-buttton .dropdown-toggle:hover {\r\n  width: auto;\r\n}\r\n\r\n/* *******************************\r\nmessage-area\r\n******************************** */\r\n\r\n.message-area {\r\n  height: 100vh;\r\n  overflow: hidden;\r\n  padding: 30px 0;\r\n  background: #f5f5f5;\r\n}\r\n\r\n.chat-area {\r\n  position: relative;\r\n  width: 100%;\r\n  background-color: #fff;\r\n  border-radius: 0.3rem;\r\n  height: 90vh;\r\n  overflow: hidden;\r\n  min-height: calc(100% - 1rem);\r\n}\r\n\r\n.chatlist {\r\n  outline: 0;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  width: 300px;\r\n  float: left;\r\n  /* padding: 15px; */\r\n  background-color: #8a8a8a;\r\n}\r\n\r\n.chat-area .modal-content {\r\n  border: none;\r\n  border-radius: 0;\r\n  outline: 0;\r\n  height: 100%;\r\n  margin: 0px!important;\r\n}\r\n\r\n.chat-area .modal-dialog-scrollable {\r\n  height: 100% !important;\r\n}\r\n\r\n.message-area .chatbox {\r\n  width: auto;\r\n  overflow: hidden;\r\n  height: 100%;\r\n  border-left: 1px solid #ccc;\r\n}\r\n\r\n.chatbox .modal-dialog,\r\n.chatlist .modal-dialog {\r\n  max-width: 100%;\r\n  margin: 0;\r\n}\r\n\r\n.msg-search {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.chat-area .form-control {\r\n  display: block;\r\n  width: 80%;\r\n  padding: 0.375rem 0.75rem;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: #222;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 1px solid #ccc;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  border-radius: 0.25rem;\r\n  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n}\r\n\r\n.chat-area .form-control:focus {\r\n  outline: 0;\r\n  box-shadow: inherit;\r\n}\r\n\r\n.message-area a.add img {\r\n  height: 36px;\r\n}\r\n\r\n.chat-area .nav-tabs {\r\n  border-bottom: 1px solid #dee2e6;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-wrap: inherit;\r\n}\r\n\r\n.chat-area .nav-tabs .nav-item {\r\n  width: 100%;\r\n}\r\n\r\n.chat-area .nav-tabs .nav-link {\r\n  width: 100%;\r\n  color: #180660;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  line-height: 1.5;\r\n  text-transform: capitalize;\r\n  margin-top: 5px;\r\n  margin-bottom: -1px;\r\n  background: 0 0;\r\n  border: 1px solid transparent;\r\n  border-top-left-radius: 0.25rem;\r\n  border-top-right-radius: 0.25rem;\r\n}\r\n\r\n.chat-area .nav-tabs .nav-item.show .nav-link,\r\n.chat-area .nav-tabs .nav-link.active {\r\n  color: #222;\r\n  background-color: #fff;\r\n  border-color: transparent transparent #000;\r\n}\r\n\r\n.chat-area .nav-tabs .nav-link:focus,\r\n.chat-area .nav-tabs .nav-link:hover {\r\n  border-color: transparent transparent #000;\r\n  isolation: isolate;\r\n}\r\n\r\n.chat-list h3 {\r\n  color: #ffffff;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  line-height: 1.5;\r\n  text-transform: capitalize;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.chat-list p {\r\n  color: #fff;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  text-transform: capitalize;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.chat-list a.d-flex {\r\n  /* margin-bottom: 15px; */\r\n  position: relative;\r\n  text-decoration: none;\r\n  padding: 10px;\r\n}\r\n\r\n\r\n\r\n.chat-list .active,\r\n.message-active\r\n {\r\n  display: block;\r\n  content: '';\r\n  clear: both;\r\n  position: absolute;\r\n  top: 40%;\r\n  right: 20px;\r\n  height: 12px;\r\n  width: 12px;\r\n  background: #ec2e7a;\r\n  border-radius: 50%;\r\n  border: 2px solid #fff;\r\n  \r\n}\r\n\r\n.msg-head h3 {\r\n  color: #222;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  line-height: 1.5;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.msg-head p {\r\n  color: #343434;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  text-transform: capitalize;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.msg-head {\r\n  padding: 15px;\r\n  border-bottom: 1px solid #ccc;\r\n}\r\n\r\n.moreoption {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: end;\r\n}\r\n\r\n.moreoption .navbar {\r\n  padding: 0;\r\n}\r\n\r\n.moreoption li .nav-link {\r\n  color: #222;\r\n  font-size: 16px;\r\n}\r\n\r\n.moreoption .dropdown-toggle::after {\r\n  display: none;\r\n}\r\n\r\n.moreoption .dropdown-menu[data-bs-popper] {\r\n  top: 100%;\r\n  left: auto;\r\n  right: 0;\r\n  margin-top: 0.125rem;\r\n}\r\n\r\n\r\n.msg-body ul {\r\n  overflow: hidden;\r\n}\r\n\r\n.msg-body ul li {\r\n  list-style: none;\r\n  margin: 15px 0;\r\n}\r\n\r\n.msg-body ul li.sender {\r\n  display: block;\r\n  width: 100%;\r\n  position: relative;\r\n}\r\n\r\n.msg-body ul li.sender:before {\r\n  /* display: block;\r\n  clear: both;\r\n  content: '';\r\n  position: absolute;\r\n  top: -6px;\r\n  left: -7px;\r\n  width: 0;\r\n  height: 0;\r\n  border-style: solid;\r\n  border-width: 0 12px 15px 12px;\r\n  border-color: transparent transparent #f5f5f5 transparent;\r\n  -webkit-transform: rotate(-37deg);\r\n  -ms-transform: rotate(-37deg);\r\n  transform: rotate(-37deg); */\r\n}\r\n\r\n.msg-body ul li.sender p {\r\n  color: #000;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  font-weight: 400;\r\n  padding: 15px;\r\n  background: #f5f5f5;\r\n  display: inline-block;\r\n  border-bottom-left-radius: 10px;\r\n  border-top-right-radius: 10px;\r\n  border-bottom-right-radius: 10px;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.msg-body ul li.sender p b {\r\n  display: block;\r\n  color: #180660;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  font-weight: 500;\r\n}\r\n\r\n.msg-body ul li.repaly {\r\n  display: block;\r\n  width: 100%;\r\n  text-align: right;\r\n  position: relative;\r\n}\r\n\r\n.msg-body ul li.repaly:before {\r\n  display: block;\r\n  clear: both;\r\n  content: '';\r\n  position: absolute;\r\n  bottom: 15px;\r\n  right: -7px;\r\n  width: 0;\r\n  height: 0;\r\n  border-style: solid;\r\n  border-width: 0 12px 15px 12px;\r\n  border-color: transparent transparent #eb307b transparent;\r\n  -webkit-transform: rotate(37deg);\r\n  -ms-transform: rotate(37deg);\r\n  transform: rotate(37deg);\r\n}\r\n\r\n.msg-body ul li.repaly p {\r\n  color: #fff;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  font-weight: 400;\r\n  padding: 15px;\r\n  background: #eb307b;\r\n  display: inline-block;\r\n  border-top-left-radius: 10px;\r\n  border-top-right-radius: 10px;\r\n  border-bottom-left-radius: 10px;\r\n  margin-bottom: 0;\r\n  text-align: justify;\r\n}\r\n\r\n.msg-body ul li.repaly p b {\r\n  display: block;\r\n  color: #061061;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  font-weight: 500;\r\n}\r\n\r\n.msg-body ul li.repaly:after {\r\n  display: block;\r\n  content: '';\r\n  clear: both;\r\n}\r\n\r\n.time {\r\n  display: block;\r\n  color: #000;\r\n  font-size: 12px;\r\n  line-height: 1.5;\r\n  font-weight: 400;\r\n}\r\n\r\n.message-area li.repaly .time {\r\n  margin-right: 20px;\r\n}\r\n\r\n.divider {\r\n  position: relative;\r\n  z-index: 1;\r\n  text-align: center;\r\n}\r\n\r\n.msg-body h6 {\r\n  text-align: center;\r\n  font-weight: normal;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  color: #222;\r\n  background: #fff;\r\n  display: inline-block;\r\n  padding: 0 5px;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.divider:after {\r\n  display: block;\r\n  content: '';\r\n  clear: both;\r\n  position: absolute;\r\n  top: 12px;\r\n  left: 0;\r\n  border-top: 1px solid #EBEBEB;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: -1;\r\n}\r\n\r\n.send-box {\r\n  padding: 15px;\r\n  border-top: 1px solid #ccc;\r\n}\r\n\r\n.send-box form {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.send-box .form-control {\r\n  display: block;\r\n  width: 85%;\r\n  padding: 0.375rem 0.75rem;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: #222;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 1px solid #ccc;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  border-radius: 0.25rem;\r\n  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n}\r\n\r\n.send-box button {\r\n  border: none;\r\n  background: #eb307b;\r\n  padding: 0.375rem 5px;\r\n  color: #fff;\r\n  border-radius: 0.25rem;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  width: 24%;\r\n  margin-left: 1%;\r\n}\r\n.send-box button i {\r\n  margin-right: 5px;\r\n}\r\n\r\n.send-btns .button-wrapper {\r\n  position: relative;\r\n  width: 125px;\r\n  height: auto;\r\n  text-align: left;\r\n  margin: 0 auto;\r\n  display: block;\r\n  background: #F6F7FA;\r\n  border-radius: 3px;\r\n  padding: 5px 15px;\r\n  float: left;\r\n  margin-right: 5px;\r\n  margin-bottom: 5px;\r\n  overflow: hidden;\r\n}\r\n\r\n.send-btns .button-wrapper span.label {\r\n  position: relative;\r\n  z-index: 1;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  cursor: pointer;\r\n  color: #343945;\r\n  font-weight: 400;\r\n  text-transform: capitalize;\r\n  font-size: 13px;\r\n}\r\n\r\n#upload {\r\n  display: inline-block;\r\n  position: absolute;\r\n  z-index: 1;\r\n  width: 100%;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  opacity: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.send-btns .attach .form-control {\r\n  display: inline-block;\r\n  width: 120px;\r\n  height: auto;\r\n  padding: 5px 8px;\r\n  font-size: 13px;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: #343945;\r\n  background-color: #F6F7FA;\r\n  background-clip: padding-box;\r\n  border: 1px solid #F6F7FA;\r\n  border-radius: 3px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.send-btns .button-wrapper span.label img {\r\n  margin-right: 5px;\r\n}\r\n\r\n.button-wrapper {\r\n  position: relative;\r\n  width: 100px;\r\n  height: 100px;\r\n  text-align: center;\r\n  margin: 0 auto;\r\n}\r\n\r\n.message-area button:focus {\r\n  outline: 0;\r\n}\r\n\r\n.add-apoint {\r\n  display: inline-block;\r\n  margin-left: 5px;\r\n}\r\n\r\n.add-apoint a {\r\n  text-decoration: none;\r\n  background: #F6F7FA;\r\n  border-radius: 8px;\r\n  padding: 8px 8px;\r\n  font-size: 13px;\r\n  font-weight: 400;\r\n  line-height: 1.2;\r\n  color: #343945;\r\n}\r\n\r\n.add-apoint a svg {\r\n  margin-right: 5px;\r\n}\r\n\r\n.chat-icon {\r\n  display: none;\r\n}\r\n\r\n.closess i {\r\n  display: none;\r\n}\r\n.message-area .modal-content{\r\n  margin-top: 0;\r\n}\r\n\r\n\r\n@media (max-width: 767px) {\r\n  .chat-icon {\r\n      display: block;\r\n      margin-right: 5px;\r\n  }\r\n  .chatlist {\r\n      width: 100%;\r\n  }\r\n  .chatbox {\r\n      width: 100%;\r\n      position: absolute;\r\n      left: 1000px;\r\n      right: 0;\r\n      background: #fff;\r\n      transition: all 0.5s ease;\r\n      border-left: none;\r\n  }\r\n  .showbox {\r\n      left: 0 !important;\r\n      transition: all 0.5s ease;\r\n  }\r\n  .msg-head h3 {\r\n      font-size: 14px;\r\n  }\r\n  .msg-head p {\r\n      font-size: 12px;\r\n  }\r\n  .msg-head .flex-shrink-0 img {\r\n      height: 30px;\r\n  }\r\n  .send-box button {\r\n      width: 28%;\r\n  }\r\n  .send-box .form-control {\r\n      width: 70%;\r\n  }\r\n  .chat-list h3 {\r\n      font-size: 14px;\r\n  }\r\n  .chat-list p {\r\n      font-size: 12px;\r\n  }\r\n  .msg-body ul li.sender p {\r\n      font-size: 13px;\r\n      padding: 8px;\r\n      border-bottom-left-radius: 6px;\r\n      border-top-right-radius: 6px;\r\n      border-bottom-right-radius: 6px;\r\n  }\r\n  .msg-body ul li.repaly p {\r\n      font-size: 13px;\r\n      padding: 8px;\r\n      border-top-left-radius: 6px;\r\n      border-top-right-radius: 6px;\r\n      border-bottom-left-radius: 6px;\r\n  }\r\n}\r\n\r\nsection.message-area.chat .tab-content .tab-pane {\r\n  padding: 0px !important;\r\n}\r\n\r\n.bottom-scroll {\r\n  overflow:auto; \r\n  display:flex !important; \r\n  flex-direction:column-reverse !important;\r\n}\r\n\r\n.alert-pitch-danger {\r\n  --vz-alert-color: #ec3087;\r\n  --vz-alert-bg: #FFE957;\r\n  --vz-alert-border-color: #ffc107;\r\n  --vz-alert-link-color: #ec3087;\r\n}\r\n\r\n.alert-pitch-gray {\r\n  --vz-alert-color: #D8D8D8;\r\n  --vz-alert-bg: #989898;\r\n  --vz-alert-border-color: #989898;\r\n  --vz-alert-link-color: #D8D8D8;\r\n}\r\n.button-gray {\r\n  padding: 10px 20px;\r\n  border: none;\r\n  background-color: #989898;\r\n  color: white;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n.button-gray:hover {\r\n  background: #989898 !important;\r\n  box-shadow: none !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
